import { useState, useEffect } from 'react';
import { useIamUserProfileStore } from '../../Store';
import getCdkSidFromOkta from '../../util/getCdkSidFromOkta';
import { SPOKE_USERS } from '../../constants';
import {
  useGetIPTemplate,
  useSaveIPTemplate,
} from './useDealerAdminQueries';
import { BaseSideSheet } from './BaseSideSheet';
import { IPRestrictionTemplateSideSheetBody } from './IPRestrictionTemplateSideSheetBody';
import {
  IPTemplateUIModel,
} from './IPRestrictionInterface';
import { SkeletonLoader } from 'cdk-radial';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

export const AdminTableBodySkeleton = (): JSX.Element => {
  return (
    <div>
      {[...Array(20)].map((item, key) => (
        <SkeletonLoader
          key={key}
          dataTestId={`loader-${key}`}
          style={{
            margin: '1.5rem 0',
            height: '20px',
          }}
          variant="text"
        ></SkeletonLoader>
      ))}
    </div>
  );
};

export default function IPRestrictionTemplateContainer({
  isTemplateOpen,
  onClose,
  setToast,
  storeId
}:any): JSX.Element {

  const iamUserInfo = useIamUserProfileStore((state: any) => state.iamUserInfo);

  const [isSideSheetCollapse, setSideSheetCollapse] = useState(isTemplateOpen);
  const [sideSheetData, setSideSheetData] = useState<IPTemplateUIModel>();

  const cdksid = getCdkSidFromOkta();
  const {t} = useTranslation();
  
  useEffect(() => {
    // eslint-disable-next-line
    setSideSheetCollapse(!isTemplateOpen);
  }, [isTemplateOpen]);

  const enterpriseId = iamUserInfo?.fullUser
    ? iamUserInfo?.fullUser?.enterprise?.id
    : !cdksid
    ? SPOKE_USERS
    : null;

  const { data } = useGetIPTemplate(
    enterpriseId,
    storeId
  );

  const { mutation: saveMutation } = useSaveIPTemplate({
    enterpriseId,
    storeId,
    onSuccess: () => {
      setToast(t('dealer-admin.ip-access.label.savedTemplateMsg') as string,'Positive',true)
      setSideSheetCollapse(true);
      onClose(true);
    },
    onError: () => {
      setToast(t('dealer-admin.ip-access.label.failedTemplateMsg') as string,'Error',true)
      setSideSheetCollapse(true);
      onClose(true);
    },
  });

  const onSave = (model: IPTemplateUIModel) => {
    if(!model.id){
        model.id= uuidv4();
    }
    saveMutation.mutate(model);
  };

  const onCancel = () => {
    setSideSheetCollapse(true);
    onClose();
  };

  useEffect(() => {
    if(data && data?.templates){
      const model = data.templates[0];
      setSideSheetData(model);
    }else{
      const model = {} as any;
      setSideSheetData(model);
    }
  }, [data]);

  return (
    <>
      {!isSideSheetCollapse && (
        <BaseSideSheet isCollapse={isSideSheetCollapse}>
          {sideSheetData && (
            <IPRestrictionTemplateSideSheetBody
              model={sideSheetData}
              onSave={onSave}
              onCancel={onCancel}
            />
          )}
        </BaseSideSheet>
      )}

    </>
  );
}
